import { flagsLoadSlice } from '@seddi/ui-feature-flags';
import { liveblocksEnhancer } from '@liveblocks/redux';
import { configureStore } from '@reduxjs/toolkit';

import { NODE_ENV } from '@/constants/env';
import { mockupSizeRangeReducer } from '@/pages/SizeRange/store/mockupSizeRange';
import { sizeRangeReducer } from '@/pages/SizeRange/store/sizeRange';
import { editorSceneLogosReducer } from '@/pages/StyleEditor/store/editorSceneLogos';
import { editorSceneStyleReducer } from '@/pages/StyleEditor/store/editorSceneStyle';
import { editorSceneRefsReducer } from '@/pages/StyleEditor/store/editorSceneRefs';
import { editorSceneReducer } from '@/pages/StyleEditor/store/editorScene';
import { localRecoloredLogosReducer } from '@/pages/StyleEditor/store/localRecoloredLogos';
import { accessModeReducer } from './accessMode';
import { liveblocksReducer } from './liveblocks/liveblocksSlice';
import { liveblocksClient } from './liveblocks';
import { newMockupReducer } from './newMockupSlice';
import { orgReducer } from './orgSlice';
import { userReducer } from './userSlice';
import { batchModeSlice } from './batchModeSlice';

const store = configureStore({
  reducer: {
    accessMode: accessModeReducer,
    editorScene: editorSceneReducer,
    editorSceneLogos: editorSceneLogosReducer, // mockupScene: editorSceneLogosReducer
    editorSceneStyle: editorSceneStyleReducer,
    editorSceneRefs: editorSceneRefsReducer,
    localRecoloredLogos: localRecoloredLogosReducer,
    flags: flagsLoadSlice.reducer,
    mockupSizeRange: mockupSizeRangeReducer,
    liveblocks: liveblocksReducer,
    newMockup: newMockupReducer,
    org: orgReducer,
    sizeRange: sizeRangeReducer,
    user: userReducer,
    batchMode: batchModeSlice.reducer,
  },
  enhancers: [
    liveblocksEnhancer({
      client: liveblocksClient,
      storageMapping: {
        editorSceneLogos: true,
        editorSceneStyle: true,
        mockupSizeRange: true,
      },
    }),
  ],
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
  devTools: NODE_ENV !== 'production',
});

export type RootDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

// Currently setup for production as well
(window as any).store = store;

export default store;
